import Chat from './chat'
import { APIClient } from '@/infrastructure/network/OpenAi/APIClient'

export default class OpenAiGateway {
  apiClient: APIClient
  Chat: Chat

  constructor(apiClient: APIClient) {
    this.apiClient = apiClient
    this.Chat = new Chat(apiClient)
  }
}
